import Logo from '../../../shared/components/logo'
import React from 'react'

type AuthCardWrapperProps = {
    /**
     * The children of the component, eg: form elements
     */
    children: React.ReactNode,

    /**
     * Card Header title
     */
    headerTitle: string,

    /**
     * Card Header description
     */
    headerDescription: string,

    /**
     * Before children elements, appears before title and description
     */
    beforeChildren?: React.ReactNode,

    /**
     * After children elements, appears at bottom of card (e.g. privacy link)
     */
    afterChildren?: React.ReactNode,

    /**
     * Hide logo from the card, default is false
     */ 
    hideLogo?: boolean,
}

function AuthCardWrapper(props: AuthCardWrapperProps) {
    return (
        <div className='bg-white my-2 py-2 px-5 md:py-3 md:px-10 rounded items-center flex flex-col gap-2 md:gap-3 w-full max-w-[500px] shadow-card'>
            {!props.hideLogo && <Logo className='md:w-[170px]' />}
            {props.beforeChildren}
            <div className="text-center space-y-0.5 md:space-y-1">
                <h1 className='text-xl md:text-2xl lg:text-3xl font-medium'>{props.headerTitle}</h1>
                <p className='text-muted-foreground text-xs md:text-sm'>{props.headerDescription}</p>
            </div>
            {props.children}
            {props.afterChildren}
        </div>
    )
}

export default AuthCardWrapper